import buildSimpleStringFilter from '../buildSimpleStringFilter'

// 'STANDARD' is a legacy value some listings still carry from before the
// shipment type was renamed to 'BINDING'; both localize to the same
// "Standard Shipping" label, so collapse them into one filter option.
const normalizeShipmentType = (value: string) =>
  value === 'STANDARD' ? 'BINDING' : value

// normalizeValue dedupes for DISPLAY only: the surviving raw facet value
// becomes the option key, so selecting the merged option sends just that one
// value to the search API and any listings tagged with the dropped synonym are
// not returned. Accepted scope — the durable fix is backend data normalization
// (migrating DEV listings off the legacy STANDARD value), not a multi-value
// filter key. Production is unaffected (no STANDARD in the index).
const AllowedShipmentTypesFilter = buildSimpleStringFilter({
  key: 'allowedShipmentTypes',
  expandedOnInit: false,
  normalizeValue: normalizeShipmentType,
})

export default AllowedShipmentTypesFilter
